import { ShareResourceModal } from '@backrs_ui/grow-ui/src/components/ShareResourceModal/ShareResourceModal';

type ShareBlueprintModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
}>;

export const ShareBlueprintModal = ({ open, onClose }: ShareBlueprintModalProps) => {
  return (
    <ShareResourceModal
      open={open}
      onClose={onClose}
      resourceType="blueprint"
      sharePath="/my-blueprint/"
      resourceName="Blueprint"
    />
  );
};
